import {
  DiscoveryApi,
  FetchApi,
  createApiRef,
} from '@backstage/core-plugin-api';
import { MonthResponse, MonthsResponse } from './types';

export interface AwsCostApi {
  getMonths(): Promise<MonthsResponse>;
  getMonth(month: string): Promise<MonthResponse>;
}

export const awsCostApiRef = createApiRef<AwsCostApi>({
  id: 'plugin.aws-cost.service',
});

export class AwsCostClient implements AwsCostApi {
  constructor(
    private readonly options: {
      discoveryApi: DiscoveryApi;
      fetchApi: FetchApi;
    },
  ) {}

  private async request<T>(path: string): Promise<T> {
    const baseUrl = await this.options.discoveryApi.getBaseUrl('aws-cost');
    const response = await this.options.fetchApi.fetch(`${baseUrl}${path}`);
    if (!response.ok) {
      throw new Error(`AWS cost request ${path} failed: ${response.status}`);
    }
    return (await response.json()) as T;
  }

  getMonths() {
    return this.request<MonthsResponse>('/months');
  }

  getMonth(month: string) {
    return this.request<MonthResponse>(
      `/month?${new URLSearchParams({ month })}`,
    );
  }
}
